__turbopack_context__.v({
  "className": "basiersquaremono_e5f91b5-module__NbTe2G__className",
  "variable": "basiersquaremono_e5f91b5-module__NbTe2G__variable",
});
